import { IPassThroughData } from '@common/interfaces/passThrough'
import { combineReducers } from 'redux'
import { createLoadingDataReducer } from '../..//helpers/redux'
import * as actions from './actions'

export default combineReducers({
  passThroughData: createLoadingDataReducer<IPassThroughData>([actions.LIST_PASS_THROUGH_REQUEST]),
})
